import { withNamespaces } from 'react-i18next';

import {
    getMessageBodyHtml,
    getMessageBodyText,
    sanitizeMailboxHtml,
} from '../../../helpers';

const MessageBody = ({
    t,
    message,
    html: htmlOverride,
}) => {
    const html = htmlOverride || getMessageBodyHtml(message);
    const text = getMessageBodyText(message);

    if (html) {
        return (
            <div
                className="mailbox-message-body"
                style={{ overflowWrap: 'anywhere' }}
                dangerouslySetInnerHTML={{
                    __html: sanitizeMailboxHtml(html),
                }}
            />
        );
    }

    if (text) {
        return (
            <pre
                className="mailbox-message-body mb-0"
                style={{
                    whiteSpace: 'pre-wrap',
                    fontFamily: 'inherit',
                    overflowWrap: 'anywhere',
                }}
            >
                {text}
            </pre>
        );
    }

    return (
        <p className="text-muted mb-0">
            {t('This message has no body.')}
        </p>
    );
};

export default withNamespaces()(MessageBody);
